import { SubjectEditPage } from "@/features/learning-content/pages/SubjectEdit";
import { Box, Stack } from "@mui/material";
import { FC } from "react";

const SubjectEdit: FC = () => {
  return (
    <Stack sx={{ mt: 1 }}>
      <Box sx={{ mb: 2.5 }}>
        <SubjectEditPage />
      </Box>
    </Stack>
  );
};

export default SubjectEdit;
